import { viewDefinitions, type View } from "@/features/views";
import { useHasUserArea } from "@/hooks/useHasUserArea";
import { useAppSelector } from "@/store";

const isView = (view: string): view is View => view in viewDefinitions;

/**
 * Resolves the user's effective active view.
 *
 * Returns `null` when the new permission system is off for the user, or the persisted active
 * view is missing/invalid.
 */
export const useActiveView = (): View | null => {
    // TODO: Remove this hook after switching to the new permission system
    const hasNewPermissionSystem = useHasUserArea(["NewPermissionSystem"]);
    const activeView = useAppSelector((state) => state.user.activeView);

    if (!hasNewPermissionSystem || activeView === null || !isView(activeView)) {
        return null;
    }

    return activeView;
};
